import { Component, OnInit } from '@angular/core';
import { StorageService } from 'src/app/services/storage/storage.service';

@Component({
  selector: 'app-confirm-auth',
  templateUrl: './confirm-auth.page.html',
  styleUrls: ['./confirm-auth.page.scss'],
})
export class ConfirmAuthPage implements OnInit {

  email = '';
  emailMask = '';

  constructor(private storageService: StorageService) { }

  async ngOnInit() {
    this.email = await this.storageService.get('emailRecover');
    this.emailMask = this.email.slice(0, 3) + this.email.slice(3, this.email.split('@')[0].length -2).replace(/./g, '*') + (this.email).slice(this.email.split('@')[0].length -2); 
  }
}